module.exports = __webpack_public_path__ + "static/media/media-5.28b20ced.jpg";